import Inputmask from "inputmask";

export default {
  beforeMount(el, binding) {
    Inputmask(binding.value).mask(el);
  },
};
